module.exports = __webpack_public_path__ + "static/media/industries-concrete-s.ce8c9e71.webp";